﻿(function (win) {
    win.LBSApp = win.LBSApp || {};
    win.LBSApp.Components = win.LBSApp.Components || {};

    win.LBSApp.Components.SubNavigation = function (
        menuContainerEl,
        siteContainerEl
    ) {
        let elements = initializeElements(menuContainerEl, siteContainerEl);
        
        let isMenuOpen = false;
        const originalTabIndexes = new Map();

        function updateElements() {
            elements = initializeElements(menuContainerEl, siteContainerEl);
            storeOriginalTabIndexes();
            setTabIndex(elements.focusableElementsInMenu, false);
        }

        function initializeElements(menuContainer, siteContainer) {
            const mobileMenuContainerEl = menuContainer.querySelector('.Submenu-mobile-container');
            const mobileMenuButtonEl = mobileMenuContainerEl.querySelector('button.Submenu-link');
            const focusableElementsSelector = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), video';

            const menuFocusableElements = Array.from(mobileMenuContainerEl.querySelectorAll(focusableElementsSelector))
                .filter(element => element != mobileMenuButtonEl);

            const allFocusableElements = Array.from(document.querySelectorAll(focusableElementsSelector))
                .filter(element =>
                    !menuFocusableElements.includes(element) && element != mobileMenuButtonEl
            );

            return {
                mobileMenuContainer: mobileMenuContainerEl,
                mobileMenuButton: mobileMenuButtonEl,
                siteContainer: siteContainerEl,
                focusableElementsInMenu: menuFocusableElements,
                focusableElementsOnSite: allFocusableElements
            }
        }

        function storeOriginalTabIndexes() {
            elements.focusableElementsOnSite.forEach(item => {
                originalTabIndexes.set(item, item.getAttribute('tabindex'));
            });
        }

        function restoreOriginalTabIndexes() {
            elements.focusableElementsOnSite.forEach(item => {
                const originalTabIndex = originalTabIndexes.get(item);
                if (originalTabIndex !== null) {
                    item.setAttribute('tabindex', originalTabIndex);
                } else {
                    item.removeAttribute('tabindex');
                }
            });
        }

        function setTabIndex(els, tabbable) {
            els.forEach(el => {
                if (tabbable) {
                    el.removeAttribute('tabindex');
                } else {
                    el.setAttribute('tabindex', '-1');
                }
            });
        }

        function attachEventListeners() {
            elements.mobileMenuButton.addEventListener('click', toggleMenu);
        }

        function toggleMenu() {
            isMenuOpen ? closeMenu() : openMenu();
        }

        function openMenu() {
            updateElements();
            setTabIndex(elements.focusableElementsOnSite, false);
            setTabIndex(elements.focusableElementsInMenu, true);
            setAriaHidden(true);
            elements.mobileMenuContainer.classList.add('is-open');


            document.addEventListener('keydown', handleKeyDown);
            toggleAriaExpanded(elements.mobileMenuButton);

            isMenuOpen = true;
        }

        function closeMenu() {
            setTabIndex(elements.focusableElementsInMenu, false);
            restoreOriginalTabIndexes();
            setAriaHidden(false);
            elements.mobileMenuContainer.classList.remove('is-open');
            

            document.removeEventListener('keydown', handleKeyDown);
            toggleAriaExpanded(elements.mobileMenuButton);

            isMenuOpen = false;
        }



        function setAriaHidden(shouldOpen) {
            //const outerElements = [...elements.headerFocusableElements, elements.main, elements.footer];
            //if (shouldOpen) {
            //    elements.menuContainer.removeAttribute('aria-hidden');
            //    outerElements.forEach(el => el.setAttribute('aria-hidden', 'true'));
            //}
            //else {
            //    elements.menuContainer.setAttribute('aria-hidden', 'true');
            //    outerElements.forEach(el => el.removeAttribute('aria-hidden'));
            //}
        }

        function handleKeyDown(event) {
            if (event.key === 'Escape') {
                closeMenu();
            }
        }

        function toggleAriaExpanded(el) {
            const isExpanded = el.getAttribute('aria-expanded') === 'true';
            el.setAttribute('aria-expanded', !isExpanded);
        }

        updateElements();
        attachEventListeners();

        return {
            toggleMenu
        };
    };
})(window);